import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";

export interface UserListItem {
  id_user?: string | number;
  userId?: string | number;
  user_id?: string | number;
  name?: string;
  surname?: string;
  email?: string;
  username?: string;
  status?: string;
}

interface UseUsersListArgs {
  corporateId: string | number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const useUsersList = ({
  corporateId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseUsersListArgs): PaginatedListResult<UserListItem> => {
  const url = corporateId
    ? `${ServicesURL.getCustomer}?corporate_id=${corporateId}`
    : null;

  return usePaginatedList<UserListItem>(url, {
    page,
    pageSize,
    search,
    fieldFilters,
  });
};

export const getUserId = (u: UserListItem): string => {
  const raw = u.id_user ?? u.userId ?? u.user_id;
  return raw != null && raw !== "" ? String(raw) : "";
};

export const getUserDisplayName = (u: UserListItem): string => {
  const full = [u.name, u.surname].filter(Boolean).join(" ").trim();
  return full || u.username || u.email || "-";
};
